import { useEffect } from 'react'
import * as React from 'react'
import { OfficeInstance } from '../../../../models/Office'
import { Loading } from '../../../../shared/components/Loading'
import { styled } from '../../../../shared/styled-components'
import { OfficeItem } from './OfficeItem'

interface IProps {
  loading?: boolean
  offices: OfficeInstance[]
  trackingSource?: string
}

export const OfficesList = ({ loading, offices, trackingSource }: IProps) => {
  return (<ListContainer>
    {offices.map(office => <OfficeItem office={office} key={office.id} trackingSource={trackingSource} />)}
    {!loading && offices.length === 0 && <NoItemsText>Leider konnten keine Praxen gefunden werden.</NoItemsText>}
    {loading && <Loading />}
  </ListContainer>)
}

const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
`

const NoItemsText = styled.div`
  text-align: center;
`
